var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { StateBuildingGraphics } from "../../graphics/StateBuildingGraphics";
import { selectIsDogTreatAvailable, selectIsQualifiedForDoghouse, } from "../../selectors/selectDoghouseInfo";
import { selectLimitedActionInfo } from "../../selectors/selectLimitedActionInfo";
import { LimitedActionType } from "../../utils/network/generated/protoTypes";
import { shallowDiffers } from "../../utils/shallowDiffers";
import { utilLimitedActionTime } from "../../utils/utilLimitedActionTime";
import { OutskirtBuilding, } from "../outskirts/OutskirtBuilding";
var OutskirtBuildingDoghouse = /** @class */ (function (_super) {
    __extends(OutskirtBuildingDoghouse, _super);
    function OutskirtBuildingDoghouse() {
        var _this = _super.call(this, IdOutskirtBuildings.Doghouse) || this;
        _this.shouldUpdate = function (props, prevProps) {
            if (!props.areAssetsLoaded) {
                return false;
            }
            return (!prevProps ||
                shallowDiffers(props.data, prevProps.data) ||
                props.isAccessible !== prevProps.isAccessible ||
                props.isTreatAvailable !== prevProps.isTreatAvailable ||
                prevProps.areAssetsLoaded !== props.areAssetsLoaded ||
                prevProps.shouldRenderCallout !== props.shouldRenderCallout);
        };
        _this.mapState = function (state) {
            var baseState = _this.baseMapState(state);
            var isTreatAvailable = selectIsDogTreatAvailable(state);
            var limitedActionInfo = selectLimitedActionInfo(state, LimitedActionType.DOGHOUSE);
            var playerCanAccessDoghouse = selectIsQualifiedForDoghouse(state);
            var secondsUntilTreatReset = utilLimitedActionTime.getLimitedActionResetRemainingTime(limitedActionInfo);
            var shouldRenderCallout = secondsUntilTreatReset === 0 && playerCanAccessDoghouse;
            return __assign({}, baseState, { isTreatAvailable: isTreatAvailable,
                shouldRenderCallout: shouldRenderCallout });
        };
        _this.update = function (props) {
            var isTreatAvailable = props.isTreatAvailable;
            var state = isTreatAvailable
                ? StateBuildingGraphics.RunningProduction
                : StateBuildingGraphics.Idle;
            _this.baseUpdate(props, state, true, props.shouldRenderCallout);
        };
        return _this;
    }
    return OutskirtBuildingDoghouse;
}(OutskirtBuilding));
export { OutskirtBuildingDoghouse };



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/OutskirtBuildingDoghouse.ts
// module id = 2172
// module chunks = 3